module.exports = __webpack_public_path__ + "static/media/epaper-background-image.a854a5ae.jpeg";